import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-required",
  "use": "svg-required-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-required\">\n  <path fill=\"none\" d=\"M0 0h24v24H0z\" />\n  <polygon points=\"17 10.774 13.925 10.774 15.462 8.111 13.538 7 12 9.663 10.462 7 8.538 8.111 10.077 10.774 7 10.774 7 12.997 10.076 12.997 8.538 15.661 10.462 16.772 12.001 14.107 13.538 16.771 15.462 15.659 13.925 12.997 17 12.997\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol